import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import wrappedLocalStorage from 'flow/utils/local-storage-utils';
import { CTI_HOST_DESCRIPTION, getLocalStorageSettingsKey, getCtiHost } from 'flow/utils/cti-config-utils';
import { Map } from 'immutable';
import { getIntegrationConfig } from 'flow/selectors/cti-integration-selectors';
import { selectLoggedInCustomer } from '../selectors/customer-selectors';
export var CTI_SETTINGS_SHOW_ON_LOAD_MODE = {
  SHOW: 'show',
  HIDDEN: 'hidden',
  USER_LOGGED_IN: 'loggedIn'
};
export var CTI_SETTINGS_OPEN_ON_CALL = {
  OFF: 'off',
  OPEN_CONTACT: 'open_contact'
};
export var CTI_SETTINGS_OPEN_ON_ANSWER = {
  OFF: 'off',
  OPEN_TICKET: 'open_ticket'
};
export var CTI_SETTINGS_KEY = {
  showOnLoad: 'tvx:settings:cti:show:on:load',
  openOnCall: 'tvx:settings:cti:open:on:call',
  hideOnAction: 'tvx:settings:cti:hide:on:action',
  logCallsAutomatically: 'tvx:settings:cti:log:calls:automatically',
  openOnAnswer: 'tvx:settings:cti:open:on:answer'
};
export var CTI_SETTINGS_LABEL = {
  showOnLoad: 'settings.cti.enable.show.on.load',
  openOnCall: 'settings.cti.open.on.call',
  hideOnAction: 'settings.cti.hide.on.action',
  logCallsAutomatically: 'settings.cti.log.calls.automatically',
  openOnAnswer: 'settings.cti.open.on.answer'
};
var CTI_SETTINGS_TEXT_LABEL = {
  showOnLoad: 'settings.cti.enable.show.on.load.text.label',
  openOnCall: 'settings.cti.open.on.call',
  hideOnAction: 'settings.cti.hide.on.action.text.label',
  logCallsAutomatically: 'settings.cti.log.calls.automatically.text.label',
  openOnAnswer: 'settings.cti.open.on.answer'
};
var showOnLoad = {
  key: CTI_SETTINGS_KEY.showOnLoad,
  value: CTI_SETTINGS_SHOW_ON_LOAD_MODE.SHOW,
  label: CTI_SETTINGS_LABEL.showOnLoad
};
var openOnCall = {
  key: CTI_SETTINGS_KEY.openOnCall,
  value: CTI_SETTINGS_OPEN_ON_CALL.OFF,
  label: CTI_SETTINGS_LABEL.openOnCall
};
var openOnAnswer = {
  key: CTI_SETTINGS_KEY.openOnAnswer,
  value: CTI_SETTINGS_OPEN_ON_ANSWER.OFF,
  label: CTI_SETTINGS_LABEL.openOnAnswer
};
var hideOnAction = {
  key: CTI_SETTINGS_KEY.hideOnAction,
  value: false,
  label: CTI_SETTINGS_LABEL.hideOnAction
};
var logCallsAutomatically = {
  key: CTI_SETTINGS_KEY.logCallsAutomatically,
  value: false,
  label: CTI_SETTINGS_LABEL.logCallsAutomatically,
  textLabel: CTI_SETTINGS_TEXT_LABEL.logCallsAutomatically
};
var allAvailableSettings = {
  showOnLoad: showOnLoad,
  openOnCall: openOnCall,
  hideOnAction: hideOnAction,
  logCallsAutomatically: logCallsAutomatically,
  openOnAnswer: openOnAnswer
};

//global settings
//legacy
export var ctiDefaultSettingObject = {
  showOnLoad: showOnLoad,
  openOnCall: openOnCall,
  hideOnAction: hideOnAction,
  openOnAnswer: openOnAnswer
};
export var setCtiSetting = function setCtiSetting(setting) {
  wrappedLocalStorage.setItem(getLocalStorageSettingsKey(), JSON.stringify(setting));
};
export var getCtiHostSetting = function getCtiHostSetting(integrationConfig) {
  var ctiHost = getCtiHost();
  if (integrationConfig && integrationConfig.has('ctiHostSetting')) {
    //the wrapper can specify which settings need to be included by ctiHostSetting on init event
    return setCtiHostSettings(integrationConfig);
  } else {
    var ctiSettingObject = _objectSpread({}, ctiDefaultSettingObject);
    //legacy here we are using server to define settings for every wrapper
    //obs! do not remove this code until there is another solution for https://telavox.atlassian.net/browse/INTE-1286
    //suggested solution in https://telavox.atlassian.net/browse/INTE-1295
    switch (ctiHost) {
      case CTI_HOST_DESCRIPTION.HUBSPOT.toLowerCase():
        //Hubspot do not support showOnLoad and hideOnAction
        delete ctiSettingObject['showOnLoad'];
        delete ctiSettingObject['hideOnAction'];
        break;
      case CTI_HOST_DESCRIPTION.FRESHDESK.toLowerCase():
        //Default to true for hideOnAction since the CTI widget covers the ticket input-field in Freshdesk.
        ctiSettingObject['hideOnAction'].value = true;
        //Fix for https://telavox.atlassian.net/browse/INTE-1286
        ctiSettingObject['showOnLoad'].value = 'hide';
        break;
      case CTI_HOST_DESCRIPTION.MICROSOFT_DYNAMICS.toLowerCase():
        //delete or append MS dynamics specific settings parameters
        break;
      case CTI_HOST_DESCRIPTION.SALESFORCE.toLowerCase():
        //delete or append salesforce specific settings parameters
        break;
      case CTI_HOST_DESCRIPTION.ZENDESK.toLowerCase():
        if (ctiSettingObject['openOnCall'].value === 'open_ticket') ctiSettingObject['openOnCall'].value = 'off';
        //delete or append zendesk specific settings parameters
        break;
      case CTI_HOST_DESCRIPTION.TELAVOX_PARTNER.toLowerCase():
        //delete or append partner specific settings parameters
        break;
      case CTI_HOST_DESCRIPTION.DEFAULT:
        //CTI host is null or not specified
        break;
      default:
        //unsupported CTI config
        break;
    }
    return ctiSettingObject;
  }
};

/**
 * Apply settings value to available settings
 */
var setValueByLocalStorage = function setValueByLocalStorage(ctiHostSetting, settings) {
  if (!ctiHostSetting) {
    //ctiHostSetting will be null if config query parameter not set on REGISTER_ORIGIN Message
    return {};
  }
  Object.keys(settings).forEach(function (key) {
    if (Object.prototype.hasOwnProperty.call(ctiHostSetting, key)) {
      ctiHostSetting[key] = _objectSpread(_objectSpread({}, ctiHostSetting[key]), settings[key]);
    }
  });
  return ctiHostSetting;
};
export var getCtiSetting = function getCtiSetting(state) {
  var integrationConfig = getIntegrationConfig(state);
  var settings = wrappedLocalStorage.getItem(getLocalStorageSettingsKey());
  var ctiHostSetting = getCtiHostSetting(integrationConfig);
  var customer = selectLoggedInCustomer(state);
  /*
   * Eniro Group AB wants this as default.
   * In case we encounter this again we should discuss a solution to follow the pattern
   * where the wrapper decides the settings
   */
  if (customer && customer.get('key') === 'customer-258837') {
    if (settings === null) {
      ctiHostSetting.logCallsAutomatically = _objectSpread(_objectSpread({}, logCallsAutomatically), {}, {
        value: true
      });
    } else {
      var tempSettings = JSON.parse(settings);
      if (tempSettings.logCallsAutomatically.value !== true) {
        //LocalStorageSetting found, set logCallsAutomatically to be true and update LocalStorageSetting
        tempSettings.logCallsAutomatically.value = true;
        settings = JSON.stringify(tempSettings);
        wrappedLocalStorage.setItem(getLocalStorageSettingsKey(), settings);
      }
    }
  }

  // remove below code when INTE-3014 is done and deployed a while
  if (settings !== null) {
    var _tempSettings$openOnC;
    var _tempSettings = JSON.parse(settings);
    if ((_tempSettings === null || _tempSettings === void 0 || (_tempSettings$openOnC = _tempSettings.openOnCall) === null || _tempSettings$openOnC === void 0 ? void 0 : _tempSettings$openOnC.value) === 'open_ticket') {
      //LocalStorageSetting found, set openOnCall to off and update LocalStorageSetting
      _tempSettings.openOnCall.value = 'off';
      settings = JSON.stringify(_tempSettings);
      wrappedLocalStorage.setItem(getLocalStorageSettingsKey(), settings);
    }
  }
  return settings === null ? ctiHostSetting : setValueByLocalStorage(ctiHostSetting, JSON.parse(settings));
};
export var hasCtiSettings = function hasCtiSettings(state) {
  var ctiSetting = getCtiSetting(state);
  return ctiSetting != null && Object.keys(ctiSetting).length > 0;
};

/**
 * Modify the global ctiSettingObject to adapt wrapper specific settings and value
 * @param {*} integrationConfig
 * @returns
 */
export var setCtiHostSettings = function setCtiHostSettings(integrationConfig) {
  //get ctiHostSetting from init CTI_REGISTER_ORIGIN data
  var settings = JSON.parse(JSON.stringify(allAvailableSettings));
  if (integrationConfig.has('ctiHostSetting')) {
    var ctiHostSetting = integrationConfig.get('ctiHostSetting', Map()).toJS();
    for (var _i = 0, _Object$entries = Object.entries(allAvailableSettings); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
        key = _Object$entries$_i[0];
      if (!Object.prototype.hasOwnProperty.call(ctiHostSetting, key)) {
        delete settings[key];
      }
    }
  }
  return settings;
};